<div class="d-flex justify-content-end pe-2 py-2">
	<button [disabled]="!selection.selected?.length" mat-raised-button color="primary" (click)="mailDialogOpen()">
		Generuj mail <i class="fa-solid fa-envelope"></i>
	</button>
</div>
<div class="dynamic-table">
	<mat-table
		mat-table
		[dataSource]="dataSource()"
		[ngStyle]="{
			width: tableWidth(),
		}"
		matSort
	>
		<ng-container matColumnDef="checkbox">
			<mat-header-cell *matHeaderCellDef>
				<mat-checkbox
					color="primary"
					(change)="$event ? toggleAllRows() : null"
					[checked]="selection.hasValue() && isAllSelected()"
					[indeterminate]="selection.hasValue() && !isAllSelected()"
				>
				</mat-checkbox>
			</mat-header-cell>
			<mat-cell *matCellDef="let element"
				><mat-checkbox
					color="primary"
					(click)="$event.stopPropagation()"
					(change)="$event ? selection.toggle(element) : null"
					[checked]="selection.isSelected(element)"
				>
				</mat-checkbox
			></mat-cell>
		</ng-container>

		<ng-container matColumnDef="Lp">
			<mat-header-cell *matHeaderCellDef> LP </mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="bc">
			<mat-header-cell *matHeaderCellDef mat-sort-header> BC </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a [routerLink]="'../../../reservation/' + element.reservation.id" target="_blank">{{
					element.reservation.id
				}}</a>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="firstName">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Imię zgłaszającego </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.reservation.ownerUser.firstName }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="lastName">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Nazwisko zgłaszającego </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.reservation.ownerUser.lastName }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="status">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.reservation.status | statusLabel }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="slotCount">
			<mat-header-cell *matHeaderCellDef mat-sort-header> il.osób </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.slot.length }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopDeparture">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Miasto wyjazdu </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.stopDepartureLocation }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopDepartureDate">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Data wyjazdu </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.stopDepartureTime | date: 'yyyy-MM-dd' }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopDepartureHour">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Godzina wyjazdu </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.stopDepartureTime | date: 'HH:mm' }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopReturnDate">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Data powrotu </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.stopReturnTime | date: 'yyyy-MM-dd' }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopReturnHour">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Godzina powrotu </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.stopReturnTime | date: 'HH:mm' }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="email">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Mail </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (element.reservation.ownerUser?.userContacts[0]?.email) {
					{{ element.reservation.ownerUser.userContacts[0].email }}
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="phone">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Tel </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.reservation.ownerUser?.userContacts[0]?.phone }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="product">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Produkt </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.product.name }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="note">
			<mat-header-cell *matHeaderCellDef> Notatka </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@for (note of element.notes; track note.id; let isLast = $last) {
					{{ note?.content }}{{ isLast ? '' : ', ' }}
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="board">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Wyżywienie </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.board.name }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="insurer">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Ubezpieczyciel </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.insurerName }}</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true" class="mat-header-custom"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
	</mat-table>
</div>
@if (isLoadingResults()) {
	<div class="spinner-container">
		<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
	</div>
}
